import "firebase/firestore"
import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocDataOnce,
} from "reactfire"

const EMPTY_LIST = []

const useLinks = () => {
  const collection = useFirestore().collection("links")
  const query = collection.orderBy("active", "desc").orderBy("startDate", "asc")
  const { status, data } = useFirestoreCollectionData(query, {
    idField: "id",
  })

  const addLink = (values) => collection.add(values)
  const updateLink = (id, values) =>
    collection.doc(id).set(values, { merge: true })
  const removeLink = (id) => collection.doc(id).delete()
  const toggleLink = (link) =>
    collection.doc(link.id).set({ active: !!!link.active }, { merge: true })

  return {
    links: data || EMPTY_LIST,
    isLoading: status === "loading",
    addLink,
    updateLink,
    toggleLink,
    removeLink,
  }
}

const useLink = (linkId) => {
  const ref = useFirestore().doc(`links/${linkId}`)
  const { status, data: link } = useFirestoreDocDataOnce(ref, {
    idField: "id",
  })

  const orderCollection = useFirestore().collection("orders")
  const timestamp = useFirestore.FieldValue.serverTimestamp()
  const placeOrder = (values) => orderCollection.add({ ...values, timestamp })

  const locationQuery = useFirestore()
    .collection("locations")
    .orderBy("name", "asc")

  const { data: locations } = useFirestoreCollectionData(locationQuery, {
    idField: "id",
  })

  return {
    link,
    status,
    placeOrder,
    locations: locations || EMPTY_LIST,
  }
}

export { useLinks, useLink }
